import React from "react";
import { SvgIcon } from "@progress/kendo-react-common";
import { checkCircleIcon, xCircleIcon } from "@progress/kendo-svg-icons";

export const CheckmarkCell = ({ dataItem, field, tdProps, invert = false }) => {
    const value = dataItem?.[field];

    const icon = (invert ? !value : value) ? checkCircleIcon : xCircleIcon;
    const color = (invert ? !value : value) ? "green" : "red";
    return (
        <td {...tdProps} style={{textAlign: "center", ...tdProps.style}}>
            <SvgIcon icon={icon} color={color} />
        </td>
    );
};